import * as React from "react";
import {cs} from "../../../../../../../../../react/chain-services";
import "./import-editing-panel.scss";
import {ErrorHighlighter} from "../../../../../../../../light/error-highlighter";
import { ImportNamingPanel } from "./import-naming-panel/import-naming-panel";
import {UseState} from "../../../../../../../../../react/use-state";

export const ImportEditingPanel = ({data, addAdditionalOptions, showErrors}) => cs(
    ["eh", (_, next) => ErrorHighlighter({next})],

    ({eh}) => (
        <div className="import-editing-panel-t9d">
            {showErrors && data.value.replaceName && !data.value.defaultName && (
                <div className="error">
                    Custom Name is Required
                </div>
            )}
            <div className="header" xd-qa-type="label" xd-qa-name="Addressing Options label">
                Addressing Options
            </div>

            {ImportNamingPanel({
                data,
                addAdditionalOptions,
                showErrors,
                customNameCss: eh.css,
            })}

        </div>
    ),
);
